import React, {
  useMemo,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { Layout, Row, Col, Form, Button, Spin, Tabs, Tooltip } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import { getRequest, patchRequest, postRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { debounce } from "lodash";
import CategoryForm from "./CategoryForm";
import { useNavigate, useParams } from "react-router-dom";
const { Content } = Layout;

const SiteWiseMaterialCompany = ({ setActiveKey }) => {
  const [unitOfMeasurement, setUnitOfMeasurement] = useState([]);
  const [state, setState] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [estimatedPrices, setEstimatedPrices] = useState({});
  const [erpCodes, setERPCodes] = useState({});
  const [categoryTree, setCategoryTree] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [priceMode, setPriceMode] = useState("common");
  const [uniqueSizes, setUniqueSizes] = useState([]);
  const formRef = useRef();
  const navigate = useNavigate();
  const { id } = useParams();
  const CompanyId = authUserData()?.company || null;
  console.log("idsss", id);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [
          categoryResponse,
          materialResponse,
          uomResponse,
          diameterResponse,
        ] = await Promise.all([
          getRequest("category-tree/?no_pagination=True"),
          id
            ? getRequest(
                `company-material-code/get-all-material-details/?site_id=${id}`
              )
            : getRequest("company-material-code/get-all-material-details/"),
          getRequest("get-category-by-uom/?category_tree=1"),
          getRequest("diameter/"),
        ]);

        console.log(
          "qqmaterialResponse",
          materialResponse,
          "categoryResponse",
          categoryResponse
        );

        const filteredCategoryResponse = categoryResponse.data.data.sort(
          (a, b) => a.id - b.id
        );
        setCategoryTree(filteredCategoryResponse);

        if (materialResponse?.data?.data) {
          setState(materialResponse.data.data);

          // Immediately set selectAllChecked after data load
          if (materialResponse.data.data.site?.[0]?.category_wise) {
            const newSelectAllChecked = {};
            materialResponse.data.data.site[0].category_wise.forEach((category, categoryIndex) => {
              category.company_material_master.forEach((subCat, subIndex) => {
                const allChecked = subCat.material_details.length > 0 &&
                  subCat.material_details.every((detail) => detail.is_checked);
                newSelectAllChecked[`${categoryIndex}_${subIndex}`] = allChecked;
              });
            });
            setSelectAllChecked(newSelectAllChecked);
          }
        } else {
          ErrorNotificationMsg(t("error_in_list_prapproval_hierarchy"));
        }

        const filteredUoMData = uomResponse.data.results.data.filter(
          (item) => item.unit_of_measurement !== "Cubic Meter"
        );
        setUnitOfMeasurement(filteredUoMData);

        if (diameterResponse.data.success) {
          const sortedSizes = diameterResponse.data.data.sort(
            (a, b) => a.ordering - b.ordering
          );
          setUniqueSizes(sortedSizes);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, t]);

  const handleEstimatedPriceChange = useCallback((categoryIndex, subCategoryIndex, detailIndex, value) => {
    const numericValue = value.replace(/,/g, "");
    if (isNaN(numericValue)) return;

    setEstimatedPrices((prev) => ({
      ...prev,
      [`${categoryIndex}_${subCategoryIndex}_${detailIndex}`]: numericValue,
    }));

    setState((prevState) => {
      const updatedCategoryWise = [...prevState.site[0].category_wise];
      updatedCategoryWise[categoryIndex].company_material_master[subCategoryIndex].material_details[detailIndex].estimated_price = numericValue;

      return {
        ...prevState,
        site: [{ ...prevState.site[0], category_wise: updatedCategoryWise }],
      };
    });
  }, []);

  const handleERPCodeChange = useCallback(
    (categoryIndex, subCategoryIndex, detailIndex, value) => {
      setERPCodes((prev) => ({
        ...prev,
        [`${categoryIndex}_${subCategoryIndex}_${detailIndex}`]: value,
      }));

      setState((prevState) => {
        const updatedCategoryWise = [...prevState.site[0].category_wise];
        updatedCategoryWise[categoryIndex].company_material_master[
          subCategoryIndex
        ].material_details[detailIndex].company_material_code = value;

        return {
          ...prevState,
          site: [{ ...prevState.site[0], category_wise: updatedCategoryWise }],
        };
      });
    },
    []
  );

  const handleAddressChange = useCallback(
    (categoryIndex, materialIndex, detailIndex, value) => {
      const unitOfMeasurementt = unitOfMeasurement.find((i) => i.id === value);

      setState((prevState) => {
        const updatedCategoryWise = [...prevState.site[0].category_wise];
        const updatedMaterialList = [
          ...updatedCategoryWise[categoryIndex].company_material_master,
        ];
        const updatedMaterialDetails = [
          ...updatedMaterialList[materialIndex].material_details,
        ];

        updatedMaterialDetails[detailIndex].unit_of_measurement = value;
        updatedMaterialDetails[detailIndex].unit_of_measurement_name =
          unitOfMeasurementt?.unit_of_measurement || value;

        updatedMaterialList[materialIndex].material_details =
          updatedMaterialDetails;
        updatedCategoryWise[categoryIndex].company_material_master =
          updatedMaterialList;

        return {
          ...prevState,
          site: [{ ...prevState.site[0], category_wise: updatedCategoryWise }],
        };
      });
    },
    [unitOfMeasurement]
  );

  const handleCheckBoxTypename = useCallback(
    (siteIndex, categoryIndex, subIndex, detailIndex, value) => {
      setState((prevState) => {
        const updatedSites = [...prevState.site];
        const updatedSite = { ...updatedSites[siteIndex] };
        const updatedCategoryWise = [...updatedSite.category_wise];
        const updatedCategory = { ...updatedCategoryWise[categoryIndex] };
        const updatedMaterialMasters = [
          ...updatedCategory.company_material_master,
        ];
        const updatedSubCategory = { ...updatedMaterialMasters[subIndex] };
        const updatedMaterialDetails = [...updatedSubCategory.material_details];

        updatedMaterialDetails[detailIndex] = {
          ...updatedMaterialDetails[detailIndex],
          is_checked: value,
        };

        updatedSubCategory.material_details = updatedMaterialDetails;
        updatedMaterialMasters[subIndex] = updatedSubCategory;
        updatedCategory.company_material_master = updatedMaterialMasters;
        updatedCategoryWise[categoryIndex] = updatedCategory;
        updatedSite.category_wise = updatedCategoryWise;
        updatedSites[siteIndex] = updatedSite;

        const allItemsChecked = updatedMaterialDetails.every(
          (detail) => detail.is_checked
        );
        setSelectAllChecked((prev) => ({
          ...prev,
          [`${categoryIndex}_${subIndex}`]: allItemsChecked,
        }));

        return { ...prevState, site: updatedSites };
      });
    },
    []
  );

  const handleSelectAllChange = useCallback(
    (e, categoryIndex, subCategoryIndex) => {
      const value = e.target.checked;

      setSelectAllChecked((prev) => ({
        ...prev,
        [`${categoryIndex}_${subCategoryIndex}`]: value,
      }));

      setState((prev) => {
        const updatedCategoryWise = [...prev.site[0].category_wise];
        updatedCategoryWise[categoryIndex].company_material_master[
          subCategoryIndex
        ].material_details = updatedCategoryWise[
          categoryIndex
        ].company_material_master[subCategoryIndex].material_details.map(
          (detail) => ({ ...detail, is_checked: value })
        );

        return {
          ...prev,
          site: [{ ...prev.site[0], category_wise: updatedCategoryWise }],
        };
      });
    },
    []
  );

  const debouncedHandleTabChange = useCallback(
    debounce((key) => {
      setSelectedCategory(key);
    }, 300),
    []
  );

  const handleSubmit = useCallback(async () => {
    const percentage = authUserData()?.company_profile_perc || null;
    const haveID =
      state?.site[0]?.category_wise?.[0]?.company_material_master?.[0]
        ?.material_details?.[0]?.id;

    const updatedState = removeDimensionAndSpecification(state);

    const dataToSend = {
      ...updatedState,
      site: updatedState?.site?.map((site) => ({
        site_id: site.site_id || null,
        site_name: site.site_name || null,
        category_wise: site?.category_wise.map((category) => ({
          ...category,
          company_material_master: category.company_material_master.map(
            (master) => ({
              ...master,
              material_details: master.material_details.map((detail) => {
                const { is_new, ...detailWithoutIsNew } = detail;

                if (detail.pricing_type === "common") {
                  return {
                    ...detailWithoutIsNew,
                    diameter_prices: [],
                    estimated_price: Number(detail.estimated_price) || 0,
                  };
                } else {
                  if (
                    detail.diameter_prices &&
                    typeof detail.diameter_prices === "object"
                  ) {
                    const diameterPricesArray = Object.entries(
                      detail.diameter_prices
                    )
                      .filter(([key]) => key !== "pricing_type")
                      .map(([diameter_value, priceData]) => {
                        const price =
                          typeof priceData === "object"
                            ? priceData.estimated_price
                            : priceData;
                        const diameterId =
                          typeof priceData === "object"
                            ? priceData.diameter_id
                            : null;

                        // Find the diameter object from uniqueSizes to get the diameter_id
                        const diameterObj = uniqueSizes?.find(
                          (size) =>
                            Number(size.diameter_value || size.value).toFixed(
                              2
                            ) === Number(diameter_value).toFixed(2)
                        );

                        return {
                          diameter_id: diameterId || diameterObj?.id || null,
                          estimated_price: Number(price) || 0,
                        };
                      });

                    return {
                      ...detailWithoutIsNew,
                      diameter_prices: diameterPricesArray,
                      estimated_price: 0,
                    };
                  }
                  return {
                    ...detailWithoutIsNew,
                    diameter_prices: [],
                    estimated_price: 0,
                  };
                }
              }),
            })
          ),
        })),
      })),
    };

    try {
      setBtnLoading(true);
      let response;
      if (haveID === null) {
        response = await postRequest(
          "company-material-code/create-material-details/",
          dataToSend
        );
      } else {
        response = await patchRequest(
          "company-material-code/update-material-details/",
          dataToSend
        );
      }

      if (response.data.success) {
        SuccessNotificationMsg(
          t(
            haveID === null
              ? "Frequently purchased material selected for future PR planning"
              : "Frequently purchased material updated for future PR planning"
          )
        );
        setBtnLoading(false);
        navigate(
          percentage === 100 ? "/delivery-address" : "/site-location-step"
        );
      }
    } catch (error) {
      console.error("Error saving material details:", error);
      setBtnLoading(false);
    }
  }, [state, CompanyId, navigate, t, uniqueSizes]);

  const removeDimensionAndSpecification = useCallback((state) => {
    const newState = { ...state };
    newState.site = newState.site.map((site) => ({
      ...site,
      category_wise: site.category_wise.map((category) => ({
        ...category,
        company_material_master: category.company_material_master.map(
          (master) => ({
            ...master,
            material_details: master.material_details.map(
              ({ dimension_standard, specification, ...rest }) => rest
            ),
          })
        ),
      })),
    }));
    return newState;
  }, []);

  const colors = ["#094E8F"];
  const [selectedCategory, setSelectedCategory] = useState("Cement");

  console.log("sstatess", state);

  const handleDiameterPriceChange = useCallback(
    (categoryIndex, subIndex, detailIndex, diameterValue, price) => {
      setState((prevState) => {
        const updatedState = { ...prevState };
        const updatedSite = [...updatedState.site];
        const updatedCategoryWise = [...updatedSite[0].category_wise];
        const updatedCompanyMaterialMaster = [
          ...updatedCategoryWise[categoryIndex].company_material_master,
        ];
        const updatedMaterialDetails = [
          ...updatedCompanyMaterialMaster[subIndex].material_details,
        ];
        const updatedDetail = { ...updatedMaterialDetails[detailIndex] };

        updatedDetail.diameter_prices = updatedDetail.diameter_prices || {};
        updatedDetail.diameter_prices[diameterValue] = price;

        updatedMaterialDetails[detailIndex] = updatedDetail;
        updatedCompanyMaterialMaster[subIndex].material_details =
          updatedMaterialDetails;
        updatedCategoryWise[categoryIndex].company_material_master =
          updatedCompanyMaterialMaster;
        updatedSite[0].category_wise = updatedCategoryWise;

        return {
          ...updatedState,
          site: updatedSite,
        };
      });
    },
    []
  );

  const activeTabContent = useMemo(() => {
    if (!state?.site?.[0]?.category_wise?.length) return null;

    const currentCategory = state.site[0].category_wise.find(
      (cat) => cat.category_tree_name === selectedCategory
    );
    if (!currentCategory) return null;

    return (
      <Form autoComplete="off" ref={formRef} onFinish={handleSubmit} className="tabscrolldivwrap" style={{height:'calc(100% - 34px)'}}>
        <div className="tabscrolldiv">
        {currentCategory.company_material_master.map((item, subIndex) => (
          <CategoryForm
            key={`${selectedCategory}-${subIndex}`}
            item={item}
            subIndex={subIndex}
            handleSelectAllChange={handleSelectAllChange}
            handleCheckBoxTypename={handleCheckBoxTypename}
            handleAddressChange={handleAddressChange}
            handleEstimatedPriceChange={handleEstimatedPriceChange}
            handleERPCodeChange={handleERPCodeChange}
            estimatedPrices={estimatedPrices}
            erpCodes={erpCodes}
            unitOfMeasurement={unitOfMeasurement}
            colors={["#094E8F"]}
            selectAllChecked={selectAllChecked}
            categoryIndex={state.site[0].category_wise.findIndex(
              (cat) => cat.category_tree_name === selectedCategory
            )}
            cat={currentCategory}
            setPriceMode={setPriceMode}
            priceMode={priceMode}
            handleDiameterPriceChange={handleDiameterPriceChange}
            diameterPrices={item.material_details.reduce(
              (acc, detail, detailIndex) => {
                acc[detailIndex] = detail.diameter_prices || {};
                return acc;
              },
              {}
            )}
            setState={setState}
          />
        ))}
        </div>
        <div className="stepsFooter">
       
          <Button
            type="primary"
            htmlType="submit"
            className="primary"
            loading={btnLoading}
          >
            Save
          </Button>
        </div>
 
      </Form>
    );
  }, [
    state,
    selectedCategory,
    handleSubmit,
    handleSelectAllChange,
    handleCheckBoxTypename,
    handleAddressChange,
    handleEstimatedPriceChange,
    handleERPCodeChange,
    estimatedPrices,
    erpCodes,
    unitOfMeasurement,
    selectAllChecked,
    priceMode,
    handleDiameterPriceChange,
    btnLoading,
  ]);

  const tabItems = useMemo(() => {
    if (!state?.site?.[0]?.category_wise?.length) return [];

    return state.site[0].category_wise.map((cat) => ({
      key: cat.category_tree_name,
      label: (
        <div className="tab-label">
          <div className="tab-text">{cat.category_tree_name}</div>
        </div>
      ),
      children:
        selectedCategory === cat.category_tree_name ? activeTabContent : null,
    }));
  }, [state, selectedCategory, activeTabContent]);

  console.log("statexzcx", state);

  return (
    <Content style={{ padding: "0" }}>
      <Spin spinning={loading}>
        <div className="searchnew" style={{ textAlign: "start" }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={12} xl={4} xxl={4}>
            <div style={{padding:'0px 16px'}}>
              <div
                style={{
                  backgroundColor: "#f0f8ff",
                  borderRadius: "2px",
                  padding: "6px 12px",
                  fontWeight: 500,
                  color: "#333",
                  display: "inline-block",
                  whiteSpace: "nowrap",
                }}
              >
                {state?.site?.[0]?.site_name} - {state?.site?.[0]?.city_name}
              </div>
              </div>
            </Col>
          </Row>

          {state?.site?.[0]?.category_wise?.length > 0 && (
            <Tabs
              defaultActiveKey={
                state.site[0].category_wise[0]?.category_tree_name
              }
              onChange={debouncedHandleTabChange}
              tabBarGutter={24}
              className="inr-tabs"
              destroyInactiveTabPane={false}
              items={tabItems}
            />
          )}
        </div>
      </Spin>
    </Content>
  );
};

SiteWiseMaterialCompany.propTypes = {
  setActiveKey: PropTypes.func.isRequired,
};

export default SiteWiseMaterialCompany;
